//
//
//
//
//
//
//

import { go } from '../../libs/router'

export default {
  props: {
    type: {
      default: 'default'
    },
    disabled: Boolean,
    mini: Boolean,
    plain: Boolean,
    text: String,
    actionType: String,
    showLoading: Boolean,
    link: String
  },
  methods: {
    onClick () {
      !this.disabled && go(this.link, this.$router)
    }
  },
  computed: {
    classes () {
      return [
        {
          'weui-btn_disabled': this.disabled,
          'weui-btn_mini': this.mini
        },
        `weui-btn_${this.type}`,
        this.plain ? `weui-btn_plain-${this.type}` : '',
        this.showLoading ? `weui-btn_loading` : ''
      ]
    }
  }
}



// WEBPACK FOOTER //
// ./~/vux/src/components/x-button/index.vue